var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditorDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#8688A5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9991 16C19.5124 16 19.9355 16.3827 19.9933 16.8827L20 17C20 17.5523 19.5554 18 18.9991 18H5.00087C4.44811 18 4 17.5561 4 17C4 16.4477 4.44463 16 5.00087 16H18.9991ZM6.99063 11C7.50827 11 7.9349 11.3827 7.99321 11.8827L8 12C8 12.5523 7.55665 13 6.99063 13H5.00937C4.45191 13 4 12.5561 4 12C4 11.4477 4.44335 11 5.00937 11H6.99063ZM12.9906 11C13.5083 11 13.9349 11.3827 13.9932 11.8827L14 12C14 12.5523 13.5566 13 12.9906 13H11.0094C10.4519 13 10 12.5561 10 12C10 11.4477 10.4434 11 11.0094 11H12.9906ZM18.9906 11C19.5083 11 19.9349 11.3827 19.9932 11.8827L20 12C20 12.5523 19.5566 13 18.9906 13H17.0094C16.4519 13 16 12.5561 16 12C16 11.4477 16.4434 11 17.0094 11H18.9906ZM18.9991 6C19.5124 6 19.9355 6.38272 19.9933 6.88267L20 7C20 7.55228 19.5554 8 18.9991 8H5.00087C4.44811 8 4 7.55614 4 7C4 6.44772 4.44463 6 5.00087 6H18.9991Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorDivider);
export default __webpack_public_path__ + "static/media/editor-divider.bbeefe82.svg";
export { ForwardRef as ReactComponent };